import React, { useContext } from 'react';
import SessionContext from 'contexts/session/context';

export const useSession = () => {
  return useContext(SessionContext);
};
